import axios from 'axios';
import { DefaultProfileType } from '../../types/default-profile-type.enum';

// PUT
// /ewosapi/v2/planandprognosis/default-profile/fishgroup/{fishGroupId}/efi/{efiProfileId}
// /ewosapi/v2/planandprognosis/default-profile/fishgroup/{fishGroupId}/egi/{egiProfileId}
// /ewosapi/v2/planandprognosis/default-profile/fishgroup/{fishGroupId}/feedstrategy/{feedStrategyId}
// /ewosapi/v2/planandprognosis/default-profile/fishgroup/{fishGroupId}/mortality/{mortalityProfileId}
export const putDefaultFishGroupProfiles = async (
  fishGroupIds: string[],
  type: DefaultProfileType,
  profileId: number,
  index: number
): Promise<{ index: number; type: DefaultProfileType }> => {
  await axios.all(
    fishGroupIds.map((id) => axios.put(`/ewosapi/v2/planandprognosis/default-profile/fishgroup/${id}/${type}/${profileId}`))
  );
  return { index, type };
};
